import React from 'react';
import './Trust.css';

const Trust = () => {
  const features = [
    'Authorized Dealership',
    'Genuine Parts & Service',
    'Expert Technicians'
  ];

  return (
    <section className="trust">
      <div className="container">
        <div className="trust-content">
          <div className="trust-text">
            <h2 className="trust-title">Trusted by Thousands</h2>
            <p className="trust-description">
              As an authorized Hyundai dealership, we bring you the assurance of genuine products, 
              certified service, and unwavering commitment to excellence.
            </p>
            <div className="trust-features">
              {features.map((feature, index) => (
                <div key={index} className="trust-feature">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>{feature}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="trust-visual">
            <div className="trust-card">
              <div className="trust-number">15+</div>
              <div className="trust-label">Years of Excellence</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Trust;

